export type Catalog = Record<string, string>

export function formatMessage(source: string, values: Record<string, string | number>, catalog: Catalog): string {
  return (catalog[source] ?? source).replace(/\{(\w+)\}/g, (token, key: string) => String(values[key] ?? token))
}

const countedMessages = [
  ['후기 {count}개', /^후기 ([\d,]+)개$/],
  ['한 주 동안 작성된 후기 {count}개', /^한 주 동안 작성된 후기 ([\d,]+)개$/],
  ['조건에 맞는 실제 후기 {count}개 · 전문 전체 표시', /^조건에 맞는 실제 후기 ([\d,]+)개 · 전문 전체 표시$/],
  ['{count}개', /^([\d,]+)개$/],
] as const

export function translate(source: string, catalog: Catalog): string {
  if (!/[가-힣ㄱ-ㅎㅏ-ㅣ]/.test(source)) return source
  const normalized = source.replace(/\s+/g, ' ').trim()
  const result = catalog[normalized]
  if (!result) {
    for (const [template, pattern] of countedMessages) {
      const match = normalized.match(pattern)
      if (match && catalog[template]) return formatMessage(template, { count: match[1] }, catalog)
    }
    const numbered = normalized.match(/^(\d{2}\s+)(.+)$/)
    if (numbered && catalog[numbered[2]]) return numbered[1] + catalog[numbered[2]]
    return source
  }
  return source.replace(source.trim(), result)
}
